(function () {
    'use strict';
    angular.module('emarket.main.currency').factory('SaleProducts', ['restmod', function (restmod) {
        return restmod.model('/sale-products');
    }]);
}());
